module.exports = __webpack_public_path__ + "media/images/countrysquared/mo-886e726caaef4801e5578af1ee2b51de.svg";